export const pt = {
    'nav.today': "Visão de Hoje",
    'nav.calendar': "Calendário de Demanda",
    'nav.rates': "Tarifas e Regras",
    'nav.automation': "Automação",
    'nav.audit': "Log de Auditoria",
    'nav.settings': "Configurações",
    'sidebar.status': "Conectado",
    'stat.occupancy': "Ocupação",
    'stat.adr': "Diária Média",
    'stat.revpar': "RevPAR",
    'stat.revenue': "Receita Est.",
    'stat.trend.vsLastWeek': "vs Sem. Passada",
    'stat.trend.onPace': "No ritmo",
    'dashboard.actions.title': "Ações Recomendadas",
    'dashboard.actions.empty': "Nenhuma ação encontrada.",
    'filter.all': "Todos",
    'filter.pricing': "Preços",
    'filter.restriction': "Restrições",
    'action.approve': "Aprovar",
    'action.reject': "Rejeitar",
    'action.risk.low': "baixo risco",
    'action.risk.medium': "médio risco",
    'action.risk.high': "alto risco",
    'action.label.current': "Atual",
    'action.label.proposed': "Proposto",
    'action.metric.impact': "Impacto",
    'action.metric.why': "Por que",
    'action.status.executed': "Auto-Executado",
    'header.search': "Pesquisar...",
    'header.logout': "Sair",
    'auto.level.title': "Nível do Piloto Automático",
    'auto.level.manual': "Manual",
    'auto.level.manual.desc': "Você aprova cada recomendação.",
    'auto.level.assisted': "Assistido",
    'auto.level.assisted.desc': "Aprova risco baixo auto. Revisar grandes mudanças.",
    'auto.level.auto': "Totalmente Automático",
    'auto.level.auto.desc': "IA gerencia preços 24/7 dentro dos seus limites.",
    'auto.level.active': "Ativo",
    'auto.guardrails.title': "Limites de Segurança",
    'auto.guardrails.maxIncrease': "Aumento Máx. Diário",
    'auto.guardrails.maxIncrease.desc': "Evitar choques de preço.",
    'auto.guardrails.maxDecrease': "Redução Máx. Diária",
    'auto.guardrails.maxDecrease.desc': "Evitar preços muito baixos.",
    'auto.guardrails.minRate': "Tarifa Mínima",
    'auto.guardrails.minRate.desc': "Nunca vender abaixo deste preço (Líquido).",
    'auto.emergency.title': "Controle de Emergência",
    'auto.emergency.label': "Parada de Emergência",
    'auto.emergency.desc': "Pausar toda automação imediatamente.",
    'auto.emergency.btn': "PAUSAR SISTEMA",
    'rates.filter.all': "Todos Tipos de Quarto",
    'rates.filter.next14': "Próximos 14 Dias",
    'rates.export': "Exportar",
    'audit.table.time': "Hora",
    'audit.table.actor': "Autor",
    'audit.table.category': "Categoria",
    'audit.table.action': "Ação",
    'audit.table.details': "Detalhes",
    'audit.table.status': "Status",
    'settings.pms.title': "Conexão PMS",
    'settings.pms.connected': "Conectado a",
    'settings.pms.disconnect': "Desconectar",
    'settings.account.title': "Conta",
    'settings.account.role': "Função",
    'settings.restart': "Reiniciar Onboarding",
    'onboard.title': "Conectar PMS",
    'onboard.desc': "Selecione seu sistema de gestão (PMS) para sincronizar.",
    'onboard.connecting': "Conectando...",
    'onboard.connect': "Conectar",
    'onboard.success.title': "Configuração Completa!",
    'onboard.success.desc': "**SynthHotel Berlin** agora está sincronizado.",
    'onboard.success.sub': "Importados 3 tipos de quartos, 14 tarifas e 243 reservas.",
    'onboard.btn.dashboard': "Ir para o Painel",
    'action.dynamic.weekend.title': "Aumentar Tarifa Fim de Semana",
    'action.dynamic.weekend.desc': "Ocupação > 75% Sábado, demanda forte (+12 quartos em 24h).",
    'action.dynamic.minstay.title': "Ativar Estadia Min. 2 Noites",
    'action.dynamic.minstay.desc': "Show da Taylor Swift. Evitar estadias de 1 noite.",
    'action.dynamic.distress.title': "Baixar Tarifa (Baixa Demanda)",
    'action.dynamic.distress.desc': "Ocupação 35% na próxima Terça. Concorrentes baixaram €10.",
    'action.dynamic.gap.title': "Preencher Lacuna: Remover CTA",
    'action.dynamic.gap.desc': "Lacuna de uma noite. Remover 'Fechado para Chegada' para vender.",
};
